<template>
  <VueEchelle libEchelle="Contrat de ville"
              idEchelle="cdv"
              idGeo="code_cv"
              libGeo="lib_cv">
  </VueEchelle>
</template>

<script>
// @ is an alias to /src
import VueEchelle from "@/components/VueEchelle.vue";


export default {
  components: {
    VueEchelle,
  }
}
</script>